import { render, staticRenderFns } from "./viewScore.vue?vue&type=template&id=5e8e69ca&scoped=true"
import script from "./viewScore.vue?vue&type=script&lang=js"
export * from "./viewScore.vue?vue&type=script&lang=js"
import style0 from "./viewScore.vue?vue&type=style&index=0&id=5e8e69ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8e69ca",
  null
  
)

export default component.exports